import { useEffect } from 'react';

type MaybeRef = React.RefObject<HTMLElement | null> | null | undefined;

/*
Fecha um painel quando o clique cai fora de TODAS as áreas informadas.

São várias refs porque o mega menu é irmão do <nav> no DOM: um clique dentro
do painel precisa contar como "dentro", senão ele fecharia no primeiro clique.

`mousedown` (e não `click`) para o painel fechar antes de um eventual clique
em link começar a navegar.
*/
export const useOnClickOutside = (
  active: boolean,
  refs: MaybeRef[],
  onOutside: () => void,
) => {
  useEffect(() => {
    if (!active) return undefined;

    const handleMouseDown = (event: MouseEvent) => {
      const target = event.target as Node;
      const inside = refs.some((ref) => ref?.current?.contains(target));
      if (!inside) onOutside();
    };

    document.addEventListener('mousedown', handleMouseDown);
    return () => document.removeEventListener('mousedown', handleMouseDown);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active, onOutside, ...refs]);
};

export default useOnClickOutside;
